import GameGalacticWarriorAPI from '@/apis/business/teacher/game-galactic-warrior-api.js'
import Enumeration from '@/common/enumeration.js'
import { handleMappingAnswer } from '@/views/pages/teacher/storage/create/common/common.js'
import _ from 'lodash'

export default {
  namespaced: true,

  state: {
    rankingGameStudents: [], // danh sách xếp hạng học sinh làm bài game
    submitGalacticGame: null,
    playMusic: true,
    selectedQuestion: 1,
    rawGalacticGame: null,
    scoreResult: null,
    isEditQuestion: false,
    editQuestion: null,
    stopCountDown: false,
    totalBonusPoint: 0
  },

  mutations: {
    // set giá trị cho danh sách xếp hạng học sinh làm bài game
    setRankingGameStudent (state, data) {
      state.rankingGameStudents = data
    },

    setSubmitGalacticGame (state, submitGalacticGame) {
      state.submitGalacticGame = submitGalacticGame
      state.submitGalacticGame.GameStoreId = state.submitGalacticGame.Id
      state.submitGalacticGame.Questions.forEach(question => {
        question.Answers.forEach(answer => {
          answer.Correct = false
          if (question.Type === Enumeration.QuestionType.Fill) {
            answer.Content = ''
          }
        })
      })
    },

    /**
     * @description set index câu hiện tại
     * @author VDDung1
     * @param {*} state
     * @param {*} sortOrder
     */
    setSelectedQuestion (state, sortOrder) {
      state.selectedQuestion = sortOrder
    },

    /**
     * @param {*} state
     * @param {*} data
     * @description set giá trị mới cho state avatarSelected
     * @author THNhat
     */
    mapAvatarSelected (state, data) {
      state.avatarSelected = data
    },

    /**
     * @description set tổng số câu hỏi
     * @author VDDung1
     * @param {*} state
     * @param {*} totalQuestion
     */
    setNumberQuestion (state, totalQuestion) {
      state.numberQuestion = totalQuestion
    },

    /**
     * @description clone câu hỏi nguyên bản
     * @author lhlong
     * @param {*} state
     * @param {*} totalQuestion
     */
    setRawGalacticGame (state, data) {
      state.rawGalacticGame = _.cloneDeep(data)
    },

    /**
     * @description set giá trị điểm tổng để xếp hạng
     * @author VDDung1
     * @param {*} state
     * @param {*} data
     */
    setScoreResult (state, data) {
      state.scoreResult = data
    },

    /**
     * @description set giá trị kiểm tra xem có chỉnh sửa câu hỏi hay không
     * @author lhlong
     * @param {*} state
     * @param {*} data
     */
    setIsEditQuestion (state, isEditQuestion) {
      state.isEditQuestion = isEditQuestion
    },

    /**
     * @description set giá trị câu hỏi sau khi chỉnh sửa
     * @author lhlong
     * @param {*} state
     * @param {*} data
     */
    setEditQuestion (state, editQuestion) {
      state.editQuestion = _.cloneDeep(editQuestion)

      if (editQuestion) {
        state.editQuestion.Answers.forEach(answer => {
          answer.Correct = false
          if (editQuestion.Type === Enumeration.QuestionType.Fill) {
            answer.Content = ''
          }
        })
        const bonusPoint = state.submitGalacticGame.Questions[editQuestion.SortOrder - 1].BonusPoint
        if (bonusPoint && typeof bonusPoint === 'number') {
          state.totalBonusPoint -= state.submitGalacticGame.Questions[editQuestion.SortOrder - 1].BonusPoint
        }

        state.submitGalacticGame.Questions[editQuestion.SortOrder - 1] = _.cloneDeep(state.editQuestion)
      }
    },

    /**
     * @description set giá trị của điểm bonus
     * @author lhlong
     * @param {*} state
     * @param {*} data
     */
    setTotalBonusPoint (state, totalBonusPoint) {
      state.totalBonusPoint += totalBonusPoint
    },

    /**
     * @description set giá trị chạy hay dừng đồng hồ
     * @author lhlong
     * @param {*} state
     * @param {*} data
     */
    setStopCountDown (state, stopCountDown) {
      state.stopCountDown = stopCountDown
    }
  },

  actions: {
    /**
     * @author PVThang
     * @param {*} context
     * @param {*} exerciseStore
     * @description Thêm học liệu
     */
    async insertExerciseStore (context, exerciseStore) {
      return await GameGalacticWarriorAPI.postAsync('', exerciseStore)
    },

    /**
     * @author PVThang
     * @param {*} context
     * @param {*} exerciseStore
     * @description update ExrciseStore
     */
    async updateExerciseStore (context, exerciseStore) {
      return await GameGalacticWarriorAPI.updateExerciseStore(exerciseStore?.Id, exerciseStore)
    },

    /**
     * @author VHSON
     * @param {*} context
     * @param {*} gameStore
     * @returns
     * @description thêm mới hoặc sửa
     */
    async upsertGameGalactic (context, gameStore) {
      gameStore.Type = Enumeration.ExerciseType.GameGalactic
      gameStore.Questions = gameStore.Questions?.map((question) => {
        delete question.CreatedDate
        delete question.ModifiedDate
        question.Answers = question.Answers?.map(answer => {
          delete answer.CreatedDate
          delete answer.ModifiedDate
          return answer
        })
        return question
      })

      const gameStoreHandle = handleMappingAnswer(gameStore, Enumeration.HandlePairingAnswerType.Convert)

      return await GameGalacticWarriorAPI.postAsync('upsert', gameStoreHandle)
    },

    /**
     * @author TTLONG
     * @description Xếp hạng học sinh làm bài game
     * @returns
     */
    async getRankingGame (context, params) {
      return await GameGalacticWarriorAPI.getAsync(
          `ranking-game/${params}`
      )
        .then((res) => {
          if (res && res.Data) {
            context.commit('setRankingGameStudent', res.Data)
          }
        })
    },

    /**
     * @description set nhạc nền cho game
     * @author lhlong
     * @param {*} state
     * @param {*} data
     */
    setPlayMusic (state, data) {
      state.playMusic = data
    },

    /**
     * @author lhlong
     * @description lấy thông tin trò chơi chiến binh thiên hà
     * @param {*} context
     * @param {*} params
     * @returns
     */
    async getStudentGalacticGame (context, params) {
      return new Promise((resolve, reject) => {
        GameGalacticWarriorAPI.getAsync('game-store', { params })
          .then((res) => {
            if (res.Data) {
              context.commit('setRawGalacticGame', res.Data)
              context.commit('setSubmitGalacticGame', res.Data)
              context.commit('setSelectedQuestion', 1)
              context.commit('setNumberQuestion', res.Data.Questions.length)
              resolve(res.Data)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
